import http, { handleApiResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import { IdNameDto } from "@/modules/letterOfCredit/letterOfCredit";

export function getPartnerTypes(): Promise<IdNameDto[]> {
  return http
    .get<ApiResponse<IdNameDto[]>>("partnertypes")
    .then(handleApiResponse);
}
